angular.module('cn')
.service('networkTypesRepository', [
  '$http',
  '$q',
  '$rootScope',
  'promiseCache',
  'ENV',
  function(
    $http,
    $q,
    $rootScope,
    promiseCache,
    ENV
  ) {

    var cache = promiseCache.create(function() {
      return $http({
        method: 'GET',
        url: `${ENV.EIAM_URL}/networktypes`
      }).then(function(res) {
        return res.data.data.network_types;
      });
    });

    this.getAll = function() {
      return cache.get();
    };

  }
]);



// WEBPACK FOOTER //
// ./src/cn/services/networkTypesRepository.js